import React, { Component } from 'react';
import cx from 'classnames';

import { PRICE_PER_SEATS_ANNUALLY, PRICE_PER_SEATS_MONTHLY } from './subscriptionTypes';

import cadenceStyles from './cadence.module.scss';

export enum CadenceTypes {
  ANNUALLY = 'Annually',
  MONTHLY = 'Monthly',
}

export const pricePerCadence: Readonly<Record<CadenceTypes, number>> = {
  [CadenceTypes.ANNUALLY]: PRICE_PER_SEATS_ANNUALLY,
  [CadenceTypes.MONTHLY]: PRICE_PER_SEATS_MONTHLY
};

interface IExternalProps {
  value?: CadenceTypes;
  onChange?: (value: string) => void;
  numberOfUsers: number;
}

interface ILocalState {
  cadence: CadenceTypes;
}

type Props = IExternalProps;

export class ToggleSlider extends Component<Props, ILocalState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      cadence: CadenceTypes.ANNUALLY
    };
    this.props.onChange?.(CadenceTypes.ANNUALLY);
    this.toggleValue = this.toggleValue.bind(this);
  }

  private toggleValue() {
    const { cadence: currentValue } = this.state;
    const value = currentValue === CadenceTypes.MONTHLY ? CadenceTypes.ANNUALLY : CadenceTypes.MONTHLY;
    this.setState({ cadence: value });
    this.props.onChange?.(value);
  }

  private renderToggle() {
    const { cadence } = this.state;
    return <div className={cadenceStyles.container}>
      <label
        annually-label={CadenceTypes.ANNUALLY}
        monthly-label={CadenceTypes.MONTHLY}
        className={cx(cadenceStyles.slider, {
          [cadenceStyles.selectedMonthly]: cadence === CadenceTypes.MONTHLY
        })}
        onClick={this.toggleValue}
      />
    </div>;
  }

  private renderPrice() {
    const { cadence } = this.state;
    const { numberOfUsers } = this.props;
    const basePrice = pricePerCadence[cadence];
    const price = basePrice * numberOfUsers;
    const isMonthly = cadence === CadenceTypes.MONTHLY;
    return <div className={cadenceStyles.info}>
      <div className={cx(cadenceStyles.discount, { [cadenceStyles.hidden]: isMonthly })}>
        {!isMonthly && '10% savings'}
      </div>
      <div className={cadenceStyles.priceContainer}>
        <div className={cadenceStyles.price}>
          {`$${price}`}
        </div>
        <div className={cadenceStyles.label}>
          Billed
          <br />
          {isMonthly ? 'monthly' : 'annually'}
        </div>
      </div>
    </div>;
  }

  render(): React.ReactNode {
    return (
      <div>
        {this.renderToggle()}
        {this.renderPrice()}
      </div>
    );
  }
}
